import { Loader } from '@googlemaps/js-api-loader';

import Component from '../component/component';

import './map.scss';

export interface IMapSettings {
    lat: string;
    lng: string;
}

export default class Map extends Component {
    static initSelector: string = '.map';

    public settings: IMapSettings;
    public googleMap: google.maps.Map;
    public latLng: google.maps.LatLng;
    public marker: google.maps.Marker;
    public lat: string;
    public lng: string;

    constructor(target: HTMLElement) {
        super(target);

        this.lat = this.element.getAttribute('data-lat');
        this.lng = this.element.getAttribute('data-lng');

        if (window.gotoAndPlay.googleMapsApiKey) {
            const loader: Loader = new Loader({
                apiKey: window.gotoAndPlay.googleMapsApiKey,
            });

            loader.load().then((): void => {
                this.latLng = new google.maps.LatLng(parseFloat(this.lat), parseFloat(this.lng));
                this.init();
            });
        } else {
            console.error('No Google Maps API key defined in gotoAndPlay');
        }
    }

    init(): void {
        this.googleMap = new google.maps.Map(this.element, {
            center: this.latLng,
            zoom: 14,
        });

        this.marker = new google.maps.Marker({
            map: this.googleMap,
            position: this.latLng,
        });
    }
}
